export default {
  // Page
  'pages.tenant.list.title': 'Tenant List',
  'pages.tenant.list.subtitle':
    'Manage all tenant accounts, subscription status and basic information',
  'pages.tenant.list.searchPlaceholder': 'Search company name, email, phone',

  // Column headers
  'pages.tenant.list.column.id': 'Tenant ID',
  'pages.tenant.list.column.tenantName': 'Tenant Name',
  'pages.tenant.list.column.tenantCode': 'Tenant Code',
  'pages.tenant.list.column.email': 'Email',
  'pages.tenant.list.column.phone': 'Phone',
  'pages.tenant.list.column.agent': 'Agent',
  'pages.tenant.list.column.industryType': 'Industry Type',
  'pages.tenant.list.column.storeCount': 'Stores',
  'pages.tenant.list.column.deviceCount': 'Devices',
  'pages.tenant.list.column.subscriptionStatus': 'Subscription Status',
  'pages.tenant.list.column.expireTime': 'Expire Time',
  'pages.tenant.list.column.createTime': 'Create Time',
  'pages.tenant.list.column.operation': 'Action',

  // Actions
  'pages.tenant.list.add': 'Add Tenant',
  'pages.tenant.list.export': 'Export',
  'pages.tenant.list.batchExport': 'Batch Export',
  'pages.tenant.list.clearSelection': 'Clear Selection',
  'pages.tenant.list.view': 'View Details',
  'pages.tenant.list.edit': 'Edit',
  'pages.tenant.list.resetPassword': 'Reset Password',
  'pages.tenant.list.resetPasswordConfirm':
    'Are you sure to reset the password?',
  'pages.tenant.list.resetAdminMenus': 'Grant Full Admin Menus',
  'pages.tenant.list.resetAdminMenusConfirm':
    "This will reset the tenant admin's menus to all current tenant menus (overwriting existing selections). Continue?",
  'pages.tenant.list.updateExpireTime': 'Update Expire Time',

  // Card titles
  'pages.tenant.list.card.basicInfo': 'Basic Information',
  'pages.tenant.list.card.accountInfo': 'Account Information',
  'pages.tenant.list.card.business': 'Business Management',

  // Form - Basic Information
  'pages.tenant.list.form.tenantName': 'Tenant Name',
  'pages.tenant.list.form.tenantNamePlaceholder': 'Please enter tenant name',
  'pages.tenant.list.form.tenantNameRequired': 'Please enter tenant name',
  'pages.tenant.list.form.tenantNameMaxLen':
    'Tenant name cannot exceed 100 characters',
  'pages.tenant.list.form.companyName': 'Company Name',
  'pages.tenant.list.form.companyNamePlaceholder': 'Please enter company name',
  'pages.tenant.list.form.agent': 'Agent',
  'pages.tenant.list.form.agentPlaceholder': 'Please select an agent',
  'pages.tenant.list.form.tenantType': 'Tenant Type',
  'pages.tenant.list.form.tenantTypePlaceholder': 'Please select tenant type',
  'pages.tenant.list.form.tenantTypeRequired': 'Please select tenant type',
  'pages.tenant.list.form.region': 'Region',
  'pages.tenant.list.form.regionPlaceholder': 'Please select region',
  'pages.tenant.list.form.regionRequired': 'Please select a region',
  'pages.tenant.list.form.address': 'Address',
  'pages.tenant.list.form.addressPlaceholder': 'Please enter address',
  'pages.tenant.list.form.addressMaxLen':
    'Address cannot exceed 255 characters',

  // Form - Account Information
  'pages.tenant.list.form.username': 'Username',
  'pages.tenant.list.form.usernamePlaceholder': 'Please enter username',
  'pages.tenant.list.form.usernameRequired': 'Please enter username',
  'pages.tenant.list.form.usernameLength': 'Username must be 4-20 characters',
  'pages.tenant.list.form.usernamePattern':
    'Username can only contain letters, numbers and underscores',
  'pages.tenant.list.form.password': 'Password',
  'pages.tenant.list.form.passwordPlaceholder': 'Please enter password',
  'pages.tenant.list.form.passwordRequired': 'Please enter password',
  'pages.tenant.list.form.passwordNoChinese':
    'Password cannot contain Chinese characters',
  'pages.tenant.list.form.passwordNotPureNum':
    'Password cannot be pure numbers',
  'pages.tenant.list.form.email': 'Email',
  'pages.tenant.list.form.emailPlaceholder': 'Please enter email',
  'pages.tenant.list.form.emailRequired': 'Please enter email',
  'pages.tenant.list.form.emailInvalid': 'Please enter a valid email format',
  'pages.tenant.list.form.contactPhone': 'Contact Phone',
  'pages.tenant.list.form.contactPhonePlaceholder':
    'Please enter contact phone',
  'pages.tenant.list.form.contactPhoneRequired': 'Please enter contact phone',
  'pages.tenant.list.form.contactPhoneInvalid':
    'Please enter a valid Philippine mobile number format',
  'pages.tenant.list.form.adminAccount': 'Admin Account',

  // Form - Business Management
  'pages.tenant.list.form.industryType': 'Industry Type',
  'pages.tenant.list.form.industryTypePlaceholder':
    'Please select industry type',
  'pages.tenant.list.form.industryTypeRequired': 'Please select industry type',
  'pages.tenant.list.form.packageId': 'Subscription Package',
  'pages.tenant.list.form.packageIdPlaceholder':
    'Please select subscription package',
  'pages.tenant.list.form.packageIdRequired':
    'Please select subscription package',
  'pages.tenant.list.form.tenantPackage': 'Tenant Package',
  'pages.tenant.list.form.subscriptionStatus': 'Subscription Status',
  'pages.tenant.list.form.expireTime': 'Expire Time',

  // Expire Time Modal
  'pages.tenant.list.modal.expireTimeTitle': 'Change Package Time',
  'pages.tenant.list.form.expireTimeRequired': 'Please select expire time',
  'pages.tenant.list.form.expireTimeNotBefore':
    'Expire time cannot be earlier than current time',
  'pages.tenant.list.form.reason': 'Reason',
  'pages.tenant.list.form.reasonPlaceholder': 'Please enter the reason',
  'pages.tenant.list.form.reasonRequired': 'Please enter the reason',

  // Messages
  'pages.tenant.list.message.deleteSuccess': 'Deleted successfully',
  'pages.tenant.list.message.resetPasswordSuccess':
    'Password reset successfully',
  'pages.tenant.list.message.resetAdminMenusSuccess':
    'Tenant admin menus have been granted in full',
  'pages.tenant.list.message.exportDev':
    'Export feature is under development...',
  'pages.tenant.list.message.selectAtLeastOne':
    'Please select at least one item',
  'pages.tenant.list.exportFileName': 'Tenant List',
  'pages.tenant.list.message.exportSuccess': 'Exported {count} tenant records',
  'pages.tenant.list.message.exportFailed': 'Export failed',
  'pages.tenant.list.message.addSuccess': 'Added successfully',
  'pages.tenant.list.message.updateSuccess': 'Updated successfully',
  'pages.tenant.list.message.updateExpireTimeSuccess': 'Updated successfully',
  'pages.tenant.list.message.getDetailFailed': 'Failed to get tenant details',

  // Common
  'pages.tenant.list.save': 'Save',
  'pages.tenant.list.cancel': 'Cancel',
  'pages.tenant.list.backToList': 'Back to List',
  'pages.tenant.list.page.addTitle': 'Add Tenant',
  'pages.tenant.list.page.editTitle': 'Edit Tenant',
};
